import GridContainer from 'components/atoms/GridContainer/GridContainer';
import GridItem from 'components/atoms/GridItem/GridItem';
import Paragraph from 'components/atoms/Paragraph/Paragraph';
import Title from 'components/atoms/Title/Title';

import React, { Fragment, useState } from 'react';
import RoutineTile from './RoutineTile';
import DetailsGroup from 'components/molecules/DetailsGroup/DetailsGroup';
import { APP_SECONDARY } from 'colours';
import OrderedList from 'components/molecules/OrderedList/OrderedList';
import Box from 'components/atoms/Box/Box';
import UnorderedList from 'components/molecules/UnorderedList/UnorderedList';
import Button from 'components/atoms/Button/Button';
import PieChart from 'components/atoms/PieChart/PieChart';
import StakeStat from 'components/atoms/StakeStat/StakeStat';
import Divider from 'components/atoms/Divider/Divider';
import Table from 'components/molecules/Table/Table';
import Link from 'components/atoms/Link/Link';
import { Trans } from 'react-i18next';

const convertPercentageToNumber = (percentage) => {
  return Number(percentage.replace('%', ''));
};

export default function SectionRoutine(props) {
  const {
    date,
    routinePartName,
    image,
    predispositionItems,
    details,
    instructionsLink,
  } = props;
  const [ratingValue, setRatingValue] = useState('N/A');

  const detailsObject = {
    leftGroupName: details.leftGroupName,
    leftGroupContent:
      details.leftGroupName.toString().toLowerCase() === 'instructions' ? (
        <OrderedList items={details.leftGroupContent.data} />
      ) : (
        <React.Fragment>
          <Title variant="h3">{details.leftGroupContent.title}</Title>
          <Box mb={2}>
            <UnorderedList items={details.leftGroupContent.data} />
          </Box>
          <Box mb={2}>
            <Link href={instructionsLink} target="_blank">
              <Button>
                <Trans i18nKey="dna24.clickForInstructions" />
              </Button>
            </Link>
          </Box>
          <Paragraph variant="body2">
            <Trans i18nKey="dna24.clickForInstructions" />
          </Paragraph>
          <Paragraph variant="body2">
            Source:{' '}
            {details.leftGroupContent.source
              ? details.leftGroupContent.source
              : 'www.edamam.com'}
          </Paragraph>
        </React.Fragment>
      ),
    ...(details.rightGroupName && { rightGroupName: details.rightGroupName }),
    ...(details.rightGroupContent && {
      rightGroupContent: (
        <React.Fragment>
          <GridContainer>
            <GridItem xs={12}>
              <GridContainer spacing={10}>
                <GridItem xs={3} sm={3}>
                  <PieChart
                    series={[
                      convertPercentageToNumber(
                        details.rightGroupContent.data[0].percentage
                      ),
                      convertPercentageToNumber(
                        details.rightGroupContent.data[1].percentage
                      ),
                      convertPercentageToNumber(
                        details.rightGroupContent.data[2].percentage
                      ),
                    ]}
                    labels={[
                      details.rightGroupContent.data[0].name,
                      details.rightGroupContent.data[1].name,
                      details.rightGroupContent.data[2].name,
                    ]}
                  />
                </GridItem>
                <GridItem xs={2} sm={3}>
                  <Box marginRight={1}>
                    <StakeStat
                      value={details.rightGroupContent.data[0].percentage}
                      valueLabel={details.rightGroupContent.data[0].name}
                    />
                  </Box>
                </GridItem>
                <GridItem xs={2} sm={3}>
                  <StakeStat
                    value={details.rightGroupContent.data[1].percentage}
                    valueLabel={details.rightGroupContent.data[1].name}
                  />
                </GridItem>
                <GridItem xs={2} sm={3}>
                  <StakeStat
                    value={details.rightGroupContent.data[2].percentage}
                    valueLabel={details.rightGroupContent.data[2].name}
                  />
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
          <Box mt={4} mb={2}>
            <Divider orientation="horizontal" height="2px" />
          </Box>
          <Table data={details.rightGroupContent.data} />
        </React.Fragment>
      ),
    }),
  };

  return (
    <Fragment>
      <GridContainer spacing={2} style={{ paddingBottom: '20px' }}>
        <GridItem xs={12}>
          <Paragraph variant="body1" align="center" textColor={APP_SECONDARY}>
            {date}
          </Paragraph>
        </GridItem>
        <GridItem xs={12}>
          <Title variant="h1" display="block" align="center">
            {routinePartName}
          </Title>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <RoutineTile
            image={image}
            ratingValue={ratingValue}
            ratingOnChange={(event, newValue) => {
              setRatingValue(newValue);
            }}
            predispositionItems={predispositionItems}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          {details && (
            <DetailsGroup
              leftGroupName={detailsObject.leftGroupName}
              rightGroupName={detailsObject.rightGroupName}
              leftGroupContent={detailsObject.leftGroupContent}
              rightGroupContent={detailsObject.rightGroupContent}
            />
          )}
        </GridItem>
      </GridContainer>
    </Fragment>
  );
}
